// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { AppProvider } from "@shopify/polaris";
import enTranslations from "@shopify/polaris/locales/en.json";
import "@shopify/polaris/build/esm/styles.css";

// 🔑 Get host from URL query string (required for Shopify App)
const params = new URLSearchParams(window.location.search);
const host = params.get("host");

// 🚨 If opened outside Shopify Admin, redirect to backend OAuth
const shop = params.get("shop") || "vr0g7p-um.myshopify.com";



const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <AppProvider i18n={enTranslations}>
    <App />
  </AppProvider>
);
